import { MultiSelect } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";

export interface MultipleChoiceFieldProps extends TellescopeFormFieldBaseProps<"multiple_choice"> {}

export const MultipleChoiceField = ({
  title,
  value = [],
  onChange,
  className,
  options,
  error,
  touched,
}: MultipleChoiceFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <MultiSelect
        value={value}
        onValueChange={(newVal) => {
          onChange(newVal);
        }}
        className={cn(className, showError && "border-destructive")}
        options={
          options?.optionDetails?.map((option) => ({
            value: option.option,
            label: `${option.option} ${option.description ?? ""}`.trim(),
          })) ?? []
        }
        searchKeywords={(option) => [option.value, option.label]}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
